/**
 * Переход между разделами урока поднимает экран к началу нового раздела (05.10.2026, сборка 1.1.1 по шнуру).
 *
 * 🔴 ЧТО БЫЛО. Кнопки «Далее» / «Назад» внизу раздела звали плавную прокрутку к началу урока В ТОТ ЖЕ МИГ, что и
 * смену раздела. React следом подменял содержимое, высота страницы менялась — и WKWebView в приложении обрывал
 * плавную прокрутку: новый раздел открывался там же, внизу. Владелец на iPhone: «POV остаётся на дне урока».
 *
 * Поэтому прокрутка — ПОСЛЕ того, как новый раздел нарисован (два кадра, как у заставки в `nativeShell.ts`), и
 * мгновенная: плавную на смене всего содержимого обрывать нечему, но и смотреть на ней нечего.
 */
export function scrollSectionTop(
  el: HTMLElement | null,
  frame: (cb: FrameRequestCallback) => number = requestAnimationFrame,
): void {
  if (!el) return;
  frame(() => frame(() => el.scrollIntoView({ block: 'start' })));
}
